import { createSelector } from '@reduxjs/toolkit';

import { connectionSelector } from 'src/selectors/connection';
import { ReduxState } from 'src/store/types';

export const currentFeatureVersionSelector = createSelector(
  connectionSelector,
  (state: ReduxState) => state.connections.featureVersionByConnectionId,
  (connection, featureVersionByConnectionId) =>
    (connection && featureVersionByConnectionId[connection.id]) || '0.0.0'
);
